/* Shared model search: chassis codes and year ranges, for the brand finder and the header search. */
(function (root) {
  function words(text) {
    return String(text || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim()
      .split(/\s+/)
      .filter(Boolean);
  }

  function rangesOf(text) {
    var raw = String(text || '');
    var ranges = [];
    var covered = {};
    var rangeRe = /((?:19|20)\d{2})\s*[-–—/]+\s*((?:19|20)\d{2})/g;
    var match;
    while ((match = rangeRe.exec(raw))) {
      var start = parseInt(match[1], 10);
      var end = parseInt(match[2], 10);
      if (end < start) {
        var swap = start;
        start = end;
        end = swap;
      }
      if (end - start > 40) continue;
      ranges.push([start, end]);
      for (var year = start; year <= end; year++) covered[year] = true;
    }
    var singles = [];
    var yearRe = /(?:19|20)\d{2}/g;
    while ((match = yearRe.exec(raw))) {
      var value = parseInt(match[0], 10);
      if (!covered[value]) singles.push(value);
    }
    return { ranges: ranges, singles: singles, hasYear: ranges.length + singles.length > 0 };
  }

  function parseQuery(input) {
    var years = [];
    var tokens = [];
    var skip = { for: 1, the: 1, mats: 1, mat: 1, floor: 1, car: 1, cars: 1 };
    words(input).forEach(function (word) {
      var bare = word.replace(/^y(?=(?:19|20)\d{2}$)/, '');
      if (/^(?:19|20)\d{2}$/.test(bare)) years.push(parseInt(bare, 10));
      else if (!skip[word]) tokens.push(word);
    });
    return { years: years, tokens: tokens, empty: years.length === 0 && tokens.length === 0 };
  }

  function yearOk(candidate, years) {
    if (!years.length) return true;
    var info = rangesOf(candidate);
    if (!info.hasYear) return false;
    return years.every(function (year) {
      var inRange = info.ranges.some(function (range) { return year >= range[0] && year <= range[1]; });
      return inRange || info.singles.indexOf(year) !== -1;
    });
  }

  function wordScore(word, token, allowShort) {
    if (word === token) return 100;
    var yearWord = /^(?:19|20)\d{2}$/.test(word);
    if ((token.length >= 2 || allowShort) && word.indexOf(token) === 0) {
      if (yearWord && token.length < 3) return 0;
      var rest = word.slice(token.length);
      if (/\d/.test(token) && /^\d/.test(rest)) return 0;
      return 80 - Math.min(20, Math.max(0, word.length - token.length));
    }
    return 0;
  }

  function tokenScore(candidate, tokens) {
    if (!tokens.length) return 1;
    var list = words(candidate);
    for (var n = 0, extra = []; n < list.length - 1; n++) {
      if (/^[a-z]+$/.test(list[n]) && /^\d/.test(list[n + 1])) extra.push(list[n] + list[n + 1]);
    }
    if (extra.length) list = list.concat(extra);
    var allowShort = tokens.length > 1;
    var total = 0;
    for (var i = 0; i < tokens.length; i++) {
      var best = 0;
      for (var j = 0; j < list.length; j++) best = Math.max(best, wordScore(list[j], tokens[i], allowShort));
      if (!best) return 0;
      total += best;
    }
    return total;
  }

  function matches(query, candidate) {
    var parsed = typeof query === 'string' ? parseQuery(query) : query;
    if (parsed.empty) return true;
    return tokenScore(candidate, parsed.tokens) > 0 && yearOk(candidate, parsed.years);
  }

  function score(query, candidate) {
    var parsed = typeof query === 'string' ? parseQuery(query) : query;
    if (!matches(parsed, candidate)) return 0;
    return tokenScore(candidate, parsed.tokens) + (parsed.years.length ? 20 : 0);
  }

  function compactKey(value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
  }

  function isBrandParentCollection(handle, title) {
    var h = String(handle || '').toLowerCase();
    var t = String(title || '').toLowerCase();
    if (/^(all-)?[a-z0-9-]+-(floor-mats|car-mats|collection|mats)$/.test(h)) {
      var rest = h.replace(/^(all-)?/, '').replace(/-(floor-mats|car-mats|collection|mats)$/, '');
      if (rest && !/\d/.test(rest) && rest.split('-').length <= 2) {
        if (/^(bmw|audi|ferrari|porsche|mercedes|mercedes-benz|lamborghini|toyota|honda|nissan|volkswagen|volvo|lexus|kia|fiat|jeep|tesla|bentley|maserati|mclaren|bugatti|hummer|chevrolet|mitsubishi|rolls-royce|aston-martin|alfa-romeo|land-rover)$/.test(rest)) {
          return true;
        }
      }
    }
    if (/\b(all models|brand collection|shop all)\b/.test(t)) return true;
    return false;
  }

  function isCarCollection(handle, title, query) {
    var blob = (String(handle || '') + ' ' + String(title || '')).toLowerCase();
    if (!blob.trim()) return false;
    if (blob.indexOf('accessor') !== -1) return false;
    if (blob.indexOf('bespoke') !== -1) return false;
    if (blob.indexOf('custom-leather') !== -1 || blob.indexOf('custom leather') !== -1) return false;
    if (isBrandParentCollection(handle, title)) return false;
    var wantsTrunk = /\btrunk\b/.test(String(query || '').toLowerCase());
    if (!wantsTrunk && /\btrunk\b/.test(blob)) return false;
    return true;
  }

  function storeRoot() {
    var value = (root.Shopify && root.Shopify.routes && root.Shopify.routes.root) || '';
    if (!value && typeof document !== 'undefined') {
      var node = document.querySelector('[data-model-root]') || document.querySelector('[data-store-root]');
      if (node) {
        value = node.getAttribute('data-model-root') || node.getAttribute('data-store-root') || '';
      }
    }
    if (!value) value = '/';
    if (value.slice(-1) !== '/') value += '/';
    return value;
  }

  function collectionUrl(handle) {
    return storeRoot() + 'collections/' + encodeURIComponent(handle || '');
  }

  function customRequestUrl(decoded) {
    var params = new URLSearchParams();
    if (decoded) {
      if (decoded.label) params.set('vehicle', decoded.label);
      if (decoded.make) params.set('make', decoded.make);
      if (decoded.model) params.set('model', decoded.model);
      if (decoded.year) params.set('year', decoded.year);
      if (decoded.bodyClass) params.set('body', decoded.bodyClass);
      if (decoded.chassisCode) params.set('chassis', decoded.chassisCode);
      if (decoded.vin) params.set('vin', decoded.vin);
    }
    try {
      params.set('returnUrl', window.location.href.split('#')[0]);
    } catch (e) {}
    var qs = params.toString();
    return 'https://help.autowin.com/custom-request' + (qs ? ('?' + qs) : '');
  }

  function shopifyQuery(input) {
    var parsed = parseQuery(input);
    if (!parsed.years.length) return String(input || '').trim();
    return parsed.tokens.concat(parsed.years.map(function (year) { return 'y' + year; })).join(' ');
  }

  function predictiveQuery(input) {
    var parsed = parseQuery(input);
    var chassis = parsed.tokens.filter(function (token) {
      return /[a-z]/.test(token) && /\d/.test(token);
    });
    var pool = chassis.length ? chassis : parsed.tokens;
    var token = pool.length ? pool[pool.length - 1] : '';
    var years = parsed.years.map(function (year) { return 'y' + year; });
    if (token && years.length) return [token].concat(years).join(' ');
    if (token) return token;
    return shopifyQuery(input);
  }

  var indexPromise = null;
  function loadIndex(url) {
    if (indexPromise) return indexPromise;
    if (!url) {
      indexPromise = Promise.resolve([]);
      return indexPromise;
    }
    indexPromise = fetch(url).then(function (response) {
      return response.ok ? response.json() : [];
    }).catch(function () { return []; });
    return indexPromise;
  }

  function brandLabel(slug) {
    var special = { bmw: 'BMW', mini: 'MINI', gmc: 'GMC', vw: 'VW', mg: 'MG' };
    if (special[slug]) return special[slug];
    return String(slug || '').split('-').filter(Boolean).map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    }).join(' ');
  }

  function searchIndex(index, query, limit) {
    var hits = [];
    (index || []).forEach(function (item) {
      if (!item || !item.h) return;
      var text = item.t + ' ' + item.h + ' ' + item.b + ' ' + (item.a || '');
      if (!isCarCollection(item.h, item.t, query)) return;
      if (!matches(query, text)) return;
      hits.push({ item: item, score: score(query, text) });
    });
    hits.sort(function (a, b) { return b.score - a.score; });
    var seenTitle = {};
    var unique = [];
    hits.forEach(function (hit) {
      var key = String(hit.item.t || '').toLowerCase().replace(/\s+/g, ' ').trim();
      if (key && seenTitle[key]) return;
      if (key) seenTitle[key] = true;
      unique.push(hit);
    });
    return unique.slice(0, limit || 8).map(function (hit) { return hit.item; });
  }

  function prettyQuery(input) {
    return String(input || '').replace(/\by((?:19|20)\d{2})\b/g, '$1');
  }

  function normalizeVin(input) {
    return String(input || '').replace(/[\s-]/g, '').toUpperCase();
  }

  function looksLikeVin(input) {
    var vin = normalizeVin(input);
    return vin.length === 17 && /^[A-HJ-NPR-Z0-9]{17}$/.test(vin);
  }

  function seriesFromModel(make, model, series) {
    var brand = String(make || '').toLowerCase();
    var name = String(model || '').toLowerCase().replace(/\s+/g, '');
    var given = String(series || '').replace(/-/g, ' ').replace(/\s+/g, ' ').trim();
    if (given && !/^\d+$/.test(given)) return given;
    if (brand === 'bmw') {
      var numbered = name.match(/^([1-8])\d{2}[a-z]*$/);
      if (numbered) return numbered[1] + ' series';
      var mCar = name.match(/^m([2-8])/);
      if (mCar) return 'm' + mCar[1];
      var xCar = name.match(/^(x[1-7]|xm|z4|i[34578x])/);
      if (xCar) return xCar[1];
    }
    if (brand.indexOf('mercedes') !== -1) {
      var merc = String(model || '').match(/^(A|B|C|E|S|CLA|CLS|GLA|GLB|GLC|GLE|GLS|SL|SLC|AMG)\b/i);
      if (merc) return merc[1].toUpperCase() === merc[1].toLowerCase() ? merc[1] + '-class' : merc[1] + ' class';
      if (/^c\d/i.test(name)) return 'c-class';
      if (/^e\d/i.test(name)) return 'e-class';
      if (/^a\d/i.test(name)) return 'a-class';
      if (/^s\d/i.test(name)) return 's-class';
    }
    if (brand === 'audi') {
      var audi = name.match(/^(a[1-8]|q[2-8]|e[-]?tron|tt|r8|rs[3-7]|s[1-8])/);
      if (audi) return audi[1].replace('etron', 'e-tron');
    }
    return given || String(model || '').replace(/-/g, ' ').trim();
  }

  function bodyHints(decoded) {
    var blob = [decoded.bodyClass, decoded.trim, decoded.model, decoded.series].join(' ').toLowerCase();
    var doors = String(decoded.doors || '');
    var hints = [];
    if (/\bgc\b|gran\s*coupe|grand\s*coupe/.test(blob)) hints.push('gran coupe');
    else if (/convertible|cabriolet|roadster|spider|spyder/.test(blob)) hints.push('convertible');
    else if (/\bcoupe\b/.test(blob)) hints.push('coupe');
    else if (/hatch|compact/.test(blob)) hints.push('hatchback');
    else if (/wagon|touring|estate/.test(blob)) hints.push('touring');
    else if (/suv|crossover|sport utility|mpv/.test(blob)) hints.push('suv');
    else if ((/sedan|saloon/.test(blob) || doors === '4') && /4\s*series/.test(String(decoded.seriesName || decoded.series || '').toLowerCase())) {
      hints.push('gran coupe');
    } else if (/sedan|saloon/.test(blob) || doors === '4') {
      hints.push('sedan');
    }
    if (!hints.length) hints.push('');
    return hints;
  }

  function chassisHints(make, seriesName, year, body) {
    if (String(make || '').toLowerCase() !== 'bmw') return [];
    var y = parseInt(year, 10) || 0;
    var series = String(seriesName || '').toLowerCase();
    var style = String(body || '').toLowerCase();
    if (series.indexOf('4 series') !== -1 || series === '4') {
      if (style.indexOf('gran coupe') !== -1) return y >= 2021 ? ['g26'] : ['f36'];
      if (style.indexOf('convertible') !== -1) return y >= 2021 ? ['g23'] : ['f33'];
      if (style.indexOf('coupe') !== -1) return y >= 2020 ? ['g22'] : ['f32'];
      return y >= 2020 ? ['g22', 'g26', '4series'] : ['f32', 'f36', '4series'];
    }
    if (series.indexOf('3 series') !== -1 || series === '3') {
      if (style.indexOf('touring') !== -1) return y >= 2019 ? ['g21'] : ['f31'];
      if (style.indexOf('gran coupe') !== -1) return ['f34'];
      if (y >= 2019) return ['g20'];
      if (y >= 2012) return ['f30'];
      return ['e90'];
    }
    if (series.indexOf('5 series') !== -1 || series === '5') {
      if (y >= 2017) return ['g30'];
      if (y >= 2010) return ['f10'];
      return ['e60'];
    }
    return [];
  }

  function vehicleQueries(decoded) {
    if (!decoded) return [];
    var make = decoded.make;
    var year = decoded.year;
    var model = decoded.model;
    var seriesName = decoded.seriesName || seriesFromModel(make, model, decoded.series);
    var seriesCompact = String(seriesName || '').toLowerCase().replace(/\s+/g, '');
    var queries = [];
    function push(parts) {
      var query = parts.filter(Boolean).join(' ').replace(/\s+/g, ' ').trim();
      if (query && queries.indexOf(query) === -1) queries.push(query);
    }
    bodyHints(Object.assign({}, decoded, { seriesName: seriesName })).forEach(function (body) {
      chassisHints(make, seriesName, year, body).forEach(function (chassis) {
        push([make, chassis, year, body]);
        push([make, chassis, body]);
        push([make, chassis, year]);
      });
      push([make, seriesCompact || seriesName, year, body]);
      push([make, seriesName, year, body]);
      push([make, seriesName, body, year]);
      push([make, seriesName, body]);
      if (body) push([make, body, year]);
    });
    push([make, seriesCompact || seriesName, year]);
    push([make, seriesName, year]);
    push([make, seriesName]);
    push([make, model, year]);
    push([make, model]);
    return queries;
  }

  function searchVehicle(index, decoded, limit) {
    if (!decoded || !decoded.make) return [];
    var seriesName = decoded.seriesName || seriesFromModel(decoded.make, decoded.model, decoded.series);
    var enriched = Object.assign({}, decoded, { seriesName: seriesName });
    var bodies = bodyHints(enriched);
    var chassisList = [];
    if (decoded.chassisCode) chassisList.push(String(decoded.chassisCode).toLowerCase());
    bodies.forEach(function (body) {
      chassisHints(decoded.make, seriesName, decoded.year, body).forEach(function (chassis) {
        if (chassis && chassisList.indexOf(chassis) === -1) chassisList.push(chassis);
      });
    });
    var queries = vehicleQueries(enriched);
    var modelSlug = compactKey(decoded.model);
    var modelTokens = words(String(decoded.model || '') + ' ' + String(seriesName || ''))
      .filter(function (token) { return token.length > 1; })
      .filter(function (token) { return ['class', 'series', 'benz', 'mercedes'].indexOf(token) === -1; })
      .filter(function (token) { return !/^\d{2,4}$/.test(token) || modelSlug === token; });
    if (modelSlug && modelSlug.length >= 3 && modelTokens.indexOf(modelSlug) === -1) modelTokens.push(modelSlug);
    var makeToken = words(decoded.make).filter(function (t) { return t !== 'benz'; })[0] || '';
    var body = bodies[0] || '';
    var conflictingBodies = ['convertible', 'cabriolet', 'coupe', 'hatchback', 'touring', 'wagon', 'avant', 'estate', 'gran coupe', 'suv']
      .filter(function (style) { return style && style !== body && !(body === 'sedan' && style === 'saloon'); });

    var best = {};
    queries.forEach(function (query, order) {
      searchIndex(index, query, 12).forEach(function (item, rank) {
        var text = String(item.t + ' ' + item.h).toLowerCase();
        var handleCompact = compactKey(item.h);
        var titleCompact = compactKey(item.t);
        var weight = (queries.length - order) * 120 - rank;
        if (makeToken && (item.b === makeToken || text.indexOf(makeToken) !== -1)) weight += 80;

        var modelHit = false;
        modelTokens.forEach(function (token) {
          var compact = compactKey(token);
          if (text.indexOf(token) !== -1) {
            weight += token.length >= 3 ? 180 : 90;
            modelHit = true;
          }
          if (compact && (handleCompact.indexOf(compact) !== -1 || titleCompact.indexOf(compact) !== -1)) {
            weight += 260;
            modelHit = true;
          }
        });
        if (modelSlug && (handleCompact.indexOf(modelSlug) !== -1 || titleCompact.indexOf(modelSlug) !== -1)) {
          weight += 400;
          modelHit = true;
        }

        if (/c class|c-class/.test(String(seriesName || '').toLowerCase()) && /(glc|gla|glb|gle|gls)-class/.test(item.h)) {
          weight -= 500;
        }

        bodies.forEach(function (style) {
          if (style && text.indexOf(style) !== -1) weight += 160;
        });
        if ((body === 'sedan' || body === 'saloon') && /sedan|saloon|w\d{3}/.test(text)) weight += 120;
        if (body) {
          conflictingBodies.forEach(function (style) {
            if (text.indexOf(style) !== -1) weight -= modelHit ? 80 : 240;
          });
        }

        chassisList.forEach(function (chassis) {
          if (chassis && text.indexOf(String(chassis).toLowerCase()) !== -1) weight += 360;
        });
        if (decoded.year && rangesOf(text).hasYear && yearOk(text, [parseInt(decoded.year, 10)])) weight += 80;
        else if (decoded.year && rangesOf(text).hasYear) weight -= 120;

        if (!best[item.h] || best[item.h].score < weight) {
          best[item.h] = { item: item, score: weight, text: text, modelHit: modelHit };
        }
      });
    });

    var ranked = Object.keys(best).map(function (key) { return best[key]; }).sort(function (a, b) {
      return b.score - a.score;
    });

    // Exact model only — never brand hubs / weak brand-only hits.
    ranked = ranked.filter(function (row) {
      if (!row.modelHit) return false;
      if (isBrandParentCollection(row.item.h, row.item.t)) return false;
      var compact = compactKey(row.item.h + ' ' + row.item.t);
      var makeOk = !makeToken || compact.indexOf(compactKey(makeToken)) !== -1 || row.item.b === makeToken || compactKey(row.item.b).indexOf(compactKey(makeToken)) !== -1;
      if (!makeOk) return false;
      if (modelSlug && modelSlug.length >= 3 && compact.indexOf(modelSlug) === -1) {
        var tokenOk = modelTokens.some(function (token) {
          var c = compactKey(token);
          return c.length >= 2 && compact.indexOf(c) !== -1;
        });
        if (!tokenOk) return false;
      }
      return row.score >= 250;
    });

    var chassisHits = ranked.filter(function (row) {
      return chassisList.some(function (chassis) {
        return chassis && row.text.indexOf(String(chassis).toLowerCase()) !== -1;
      });
    });
    if (chassisHits.length) ranked = chassisHits;

    if (body) {
      var bodyHits = ranked.filter(function (row) {
        if (body === 'sedan' || body === 'saloon') {
          return /sedan|saloon|w\d{3}/.test(row.text) && !/convertible|coupe|wagon|estate|touring|avant|suv/.test(row.text);
        }
        return row.text.indexOf(body) !== -1;
      });
      if (bodyHits.length) ranked = bodyHits;
    }

    ranked.sort(function (a, b) {
      if (b.score !== a.score) return b.score - a.score;
      var aYear = /\d{4}/.test(a.item.h) ? 1 : 0;
      var bYear = /\d{4}/.test(b.item.h) ? 1 : 0;
      if (bYear !== aYear) return bYear - aYear;
      return b.item.h.length - a.item.h.length;
    });

    var max = limit == null ? 1 : Math.max(1, limit);
    return ranked.slice(0, max).map(function (row) { return row.item; });
  }

  function decodeVin(input) {
    var vin = normalizeVin(input);
    if (!looksLikeVin(vin)) return Promise.resolve(null);
    return fetch('https://vpic.nhtsa.dot.gov/api/vehicles/DecodeVinValues/' + encodeURIComponent(vin) + '?format=json', {
      signal: typeof AbortSignal !== 'undefined' && AbortSignal.timeout ? AbortSignal.timeout(8000) : undefined
    })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (data) {
        var row = data && data.Results && data.Results[0] ? data.Results[0] : null;
        if (!row) return null;
        var make = String(row.Make || '').trim();
        var model = String(row.Model || '').trim();
        var year = String(row.ModelYear || '').trim();
        var series = String(row.Series || '').trim();
        var trim = String(row.Trim || '').trim();
        var bodyClass = String(row.BodyClass || '').trim();
        var doors = String(row.Doors || '').trim();
        if (!make && !model) return null;
        var seriesName = seriesFromModel(make, model, series);
        var labelBits = [year, make, model];
        if (seriesName && labelBits.join(' ').toLowerCase().indexOf(seriesName.toLowerCase()) === -1) labelBits.push(seriesName);
        if (trim && /gc|gran/i.test(trim)) labelBits.push('Gran Coupe');
        else if (bodyClass) labelBits.push(bodyClass.split('/')[0]);
        var decoded = {
          vin: vin,
          make: make,
          model: model,
          year: year,
          series: series,
          seriesName: seriesName,
          trim: trim,
          bodyClass: bodyClass,
          doors: doors,
          label: labelBits.filter(Boolean).join(' '),
          query: vehicleQueries({
            make: make,
            model: model,
            year: year,
            series: series,
            seriesName: seriesName,
            trim: trim,
            bodyClass: bodyClass,
            doors: doors
          })[0] || [make, seriesName || model, year].filter(Boolean).join(' ')
        };
        return decoded;
      })
      .catch(function () { return null; });
  }

  var api = {
    words: words,
    rangesOf: rangesOf,
    parseQuery: parseQuery,
    matches: matches,
    score: score,
    isCarCollection: isCarCollection,
    shopifyQuery: shopifyQuery,
    predictiveQuery: predictiveQuery,
    loadIndex: loadIndex,
    brandLabel: brandLabel,
    searchIndex: searchIndex,
    searchVehicle: searchVehicle,
    vehicleQueries: vehicleQueries,
    prettyQuery: prettyQuery,
    normalizeVin: normalizeVin,
    looksLikeVin: looksLikeVin,
    decodeVin: decodeVin,
    customRequestUrl: customRequestUrl,
    storeRoot: storeRoot,
    collectionUrl: collectionUrl,
    isBrandParentCollection: isBrandParentCollection
  };

  root.AwModelSearch = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;

  if (typeof document !== 'undefined' && !root.__awModelSearchBound) {
    root.__awModelSearchBound = true;
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.querySelector) return;
      var input = form.querySelector('input[name="q"]');
      if (!input || !form.action || form.action.indexOf('/search') === -1) return;
      var rewritten = api.shopifyQuery(input.value);
      if (!rewritten || rewritten === String(input.value || '').trim()) return;
      event.preventDefault();
      var url = new URL(form.action, window.location.origin);
      new FormData(form).forEach(function (value, key) {
        if (key !== 'q') url.searchParams.append(key, value);
      });
      url.searchParams.set('q', rewritten);
      if (!url.searchParams.get('type')) url.searchParams.set('type', 'product');
      window.location.assign(url.toString());
    }, true);

    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.main-search__input').forEach(function (input) {
        if (input.value) input.value = api.prettyQuery(input.value);
      });
      if (!/\/search\/?$/.test(window.location.pathname)) return;
      var grid = document.querySelector('#content .product-grid, .section-search-template .product-grid, main .product-grid');
      if (!grid) return;
      var filled = Array.prototype.filter.call(document.querySelectorAll('.main-search__input'), function (input) { return input.value; })[0];
      var terms = filled ? filled.value : '';
      var parsed = api.parseQuery(terms);
      var indexNode = document.querySelector('[data-model-index]');
      var indexUrl = indexNode ? indexNode.getAttribute('data-model-index') : '';
      var applyYear = function () {
        if (parsed.empty || !parsed.years.length) return;
        var shown = 0;
        grid.querySelectorAll('.product-block').forEach(function (block) {
          if (block.hidden) return;
          var text = block.getAttribute('data-search-text') || (block.querySelector('.product-block__title') || {}).innerText || '';
          var ok = api.matches(parsed, text);
          block.hidden = !ok;
          if (ok) shown += 1;
        });
        if (!shown && !grid.querySelector('.aw-search-index-hit')) {
          var note = document.createElement('h5');
          note.className = 'align-centre fully-spaced-row';
          note.textContent = 'No model matches that year.';
          grid.before(note);
        }
      };
      if (!indexUrl) {
        applyYear();
        return;
      }
      api.loadIndex(indexUrl).then(function (index) {
        if (parsed.empty) {
          applyYear();
          return;
        }
        var hits = api.searchIndex(index, terms, 12);
        var allowed = {};
        hits.forEach(function (item) { allowed[item.h] = item; });
        var seen = {};
        grid.querySelectorAll('.collection-block').forEach(function (block) {
          var handle = block.getAttribute('data-model-handle') || '';
          if (allowed[handle]) seen[handle] = true;
          else block.remove();
        });
        hits.forEach(function (item) {
          if (seen[item.h]) return;
          var link = document.createElement('a');
          link.className = 'product-block collection-block aw-search-index-hit';
          link.href = api.collectionUrl(item.h);
          link.setAttribute('data-model-handle', item.h);
          var brand = api.brandLabel(item.b);
          link.innerHTML = (brand ? '<span class="aw-search-origin">' + brand + '</span>' : '')
            + '<span class="product-block__title">' + item.t.replace(/[&<>]/g, function (char) {
              return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;' })[char];
            }) + '</span>';
          grid.appendChild(link);
        });
        applyYear();
      }).catch(applyYear);
    });
  }
})(typeof window !== 'undefined' ? window : globalThis);
